import 'bootstrap/dist/css/bootstrap.css';
import { useState } from 'react';
import Spinner from '../../shared/spinner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import InputMask from 'react-input-mask';
import { ClienteAtualizacaoDTO } from '../../shared/dto/clienteAtualizacaoDTO';
import { format } from 'date-fns';
import { Cliente } from '../../shared/model/Cliente';
import { ClienteEndereco } from '../../shared/model/clienteEndereco';
import ScrollToTopButton from '../../shared/scrollToTopButton';
import ClienteService from '../../services/clienteService';
import CustomAlert from '../../shared/customAlert';
import { useVerificaPermissao } from '../../shared/useVerificaPermissao';

function ClienteConsultaHistoricoComponent() {
  useVerificaPermissao();
  const [alert, setAlert] = useState<{ message: string, type: 'success' | 'warning' | 'error' } | null>(null);
  const [loading, setLoading] = useState(false);
  const [cpf, setCpf] = useState('');
  const [cliente, setCliente] = useState<ClienteAtualizacaoDTO[]>([]);

  const [showModal, setShowModal] = useState(false);
  const [clienteSelecionado, setClienteSelecionado] = useState<Cliente>();
  const [historicoSelecionado, setHistoricoSelecionado] = useState<ClienteAtualizacaoDTO>();
  const [enderecoResidencia, setEnderecoResidencia] = useState<ClienteEndereco>();
  const [enderecoComercial, setEnderecoComercial] = useState<ClienteEndereco>();
  const [enderecoCobranca, setEnderecoCobranca] = useState<ClienteEndereco>();

  const clienteService: ClienteService = new ClienteService();

  const listarClientePorCpf = async () => {
    if (cpf === '') return setAlert({ message: 'Preencha o campo de busca!', type: 'warning' });
    try {
      setLoading(true);

      const responseList = await clienteService.listarClienteHistoricoPorCpf(cpf);
      const json = responseList.data;
      setCliente(json);
      
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  };

  const abrirModalDetalhes = async (itemHistorico: ClienteAtualizacaoDTO) => {
    try {
      setLoading(true);
      setHistoricoSelecionado(itemHistorico);
      
      const responseList = await clienteService.listarClientePorId(parseInt(itemHistorico.idCliente));
      
      const json = responseList.data.cliente;
      const jsonEnderecos = responseList.data.enderecos;

      setClienteSelecionado(json);
      
      setEnderecoComercial(undefined);
      setEnderecoResidencia(undefined);
      setEnderecoCobranca(undefined);

      if (jsonEnderecos) {
        jsonEnderecos.forEach((end: ClienteEndereco) => {
          if (end.tipoEndereco === 'Comercial') {
            setEnderecoComercial(end);
          } else if (end.tipoEndereco === 'Residencial') {
            setEnderecoResidencia(end);
          } else if (end.tipoEndereco === 'Cobrança') {
            setEnderecoCobranca(end);
          }
        });
      }
      
      setShowModal(true);
      setLoading(false);
    } catch (err: any) {
      setLoading(false);
      setAlert({ message: err.response?.data || 'Ocorreu um erro ao buscar os detalhes do cliente.', type: 'error' });
      console.error(err);
    }
  };

  const aprovarReprovarAtualizacao = async (aprovar: boolean) => {
    if (!historicoSelecionado) return;
    
    try {
      setLoading(true);
      await clienteService.aprovarReprovarAtualizacaoPorId(
        historicoSelecionado.idAtualizacao, 
        aprovar, 
        historicoSelecionado.idCliente
      );
      
      setAlert({ 
        message: `Atualização ${aprovar ? 'aprovada' : 'reprovada'} com sucesso!`, 
        type: 'success' 
      });
      
      // Atualiza a lista após a ação
      await listarClientePorCpf();
      fecharModal();
      setLoading(false);
    } catch (err: any) {
      setLoading(false);
      setAlert({ 
        message: err.response?.data || `Ocorreu um erro ao ${aprovar ? 'aprovar' : 'reprovar'} a atualização.`, 
        type: 'error' 
      });
      console.error(err);
    }
  };

  const fecharModal = () => {
    setShowModal(false);
    setClienteSelecionado(undefined);
    setHistoricoSelecionado(undefined);
  };

  // Função para determinar se o status é PEN (Pendente)
  const isStatusPendente = (item: ClienteAtualizacaoDTO) => {
    return item.aprovado === true && !item.dtAprovacao;
  };

  return (
    <>
      {alert && (<CustomAlert message={alert.message} type={alert.type} onClose={()=>setAlert(null)} />)}
      <div className="position-relative m-md-3">
        {loading ? <Spinner loading={loading} /> : (
          <>
            <div className="card" style={{ marginTop: '25px' }}>
              <div className="card-body">
                <div className="card-header">
                  <h5>Cliente &gt; Aprovar Atualização Cadastral</h5>
                </div>
                <div className="row" style={{ marginTop: '10px' }}>
                  <div className="col-md-2">
                    <div className="form-group">
                      <label>Digite o CPF do Cliente <span style={{ color: 'red' }}>*</span></label>
                      <InputMask required mask="999.999.999-99" type="text" className="form-control" value={cpf} onChange={(e) => { setCpf(e.target.value); setCliente([]); }} />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <button className="input-group-btn"
                      style={{
                        backgroundColor: 'white', width: '30%', marginLeft: '10px', display: 'flex', alignItems: 'center',
                        justifyContent: 'center', border: '1px solid LightGrey', borderRadius: '5px', height: '54px', minWidth: '50px'
                      }} onClick={listarClientePorCpf}>
                      <a >
                        <FontAwesomeIcon icon={faSearch} style={{ color: 'black' }} />
                      </a>
                    </button>
                  </div>
                </div>
                {cliente.length > 0 && (
                  <div className="card-body">
                    <div className="table-responsive" style={{ width: '100%', borderWidth: '1px' }}>
                      <table className="table table-bordered table-striped" cellSpacing="2" cellPadding="4" rules="all" style={{ border: '3px solid #999999', color: 'Black', width: '100%' }}>
                        <thead>
                          <tr className="GridHeaderStyle" style={{ backgroundColor: 'white', color: 'black' }}>
                            <th style={{ textAlign: 'center' }} scope="col" id="App-header-table">Código</th>
                            <th style={{ textAlign: 'center' }} scope="col" id="App-header-table">Status</th>
                            <th style={{ textAlign: 'center' }} scope="col" id="App-header-table">CPF</th>
                            <th style={{ textAlign: 'center' }} scope="col" id="App-header-table">Nome</th>
                            <th style={{ textAlign: 'center' }} scope="col" id="App-header-table">Data Inclusão</th>
                            <th style={{ textAlign: 'center' }} scope="col" id="App-header-table">Proposta</th>
                            <th style={{ textAlign: 'center' }} scope="col" id="App-header-table">Ações</th>
                          </tr>
                        </thead>
                        <tbody>
                          {cliente.map((item) => (
                            <tr className="GridRowStyle" key={item.idCliente}>
                              <td style={{ textAlign: 'center' }}>{item.idCliente}</td>
                              <td style={{ textAlign: 'center', backgroundColor: item.aprovado === true && item.dtAprovacao? 'green' : item.aprovado === true && !item.dtAprovacao ? 'yellow' : item.aprovado === false && item.dtAprovacao ? 'red' : item.ativo === true ? 'green' : 'white', color: item.aprovado === true && item.dtAprovacao ? 'black' : 'black', }}>{item.aprovado === true && item.dtAprovacao ? 'APR' : item.aprovado === true && !item.dtAprovacao ? 'PEN' : item.aprovado=== false && item.dtAprovacao ? 'REP' : item.ativo === true ? 'APR' : ''}</td>
                              <td style={{ textAlign: 'center' }}>{item.cpf}</td>
                              <td style={{ textAlign: 'center' }}>{item.nome}</td>
                              <td style={{ textAlign: 'center' }}>{item.dtInclusao}</td>
                              <td style={{ textAlign: 'center' }}>{item.proposta}</td>
                              <td style={{ textAlign: 'center' }}>
                                <button
                                  style={{ backgroundColor: 'black', color: 'white', border: '2px solid darkblack', borderRadius: '5px', width: '40px', height: '30px', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginLeft: '5px', marginRight: '5px' }}
                                  title="Visualizar" onClick={() => { abrirModalDetalhes(item); }}>
                                  <FontAwesomeIcon icon={faSearch} />
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* Modal de Detalhes */}
            {showModal && historicoSelecionado && (
              <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex={-1}>
                <div className="modal-dialog modal-lg modal-dialog-centered">
                  <div className="modal-content">
                    <div className="modal-header">
                      <h5 className="modal-title">Detalhes do Cliente - Histórico</h5>
                      <button type="button" className="btn-close" onClick={fecharModal}></button>
                    </div>
                    <div className="modal-body">
                      <div className="card">
                        <div className="card-header">
                          <strong>Dados Básicos</strong>
                        </div>
                        <div className="card-body">
                          <div className="row">
                            <div className="col-md-3 form-group">
                              <label>Código</label>
                              <div className="form-control" style={{ minHeight: "38px", backgroundColor: "LightGrey" }}>{historicoSelecionado.idCliente}</div>
                            </div>
                            <div className="col-md-4">
                              <label>CPF</label>
                              <div className="form-control" style={{ minHeight: "38px", backgroundColor: "LightGrey" }}>{historicoSelecionado.cpf}</div>
                            </div>
                            <div className="col-md-5">
                              <label>Nome </label>
                              <div className="form-control" style={{ minHeight: "38px", backgroundColor: "LightGrey" }}>{historicoSelecionado.nome}</div>
                            </div>
                          </div>
                          <div className="row mt-3">
                            <div className="col-md-4">
                              <label>Data Nascimento</label>
                              <div className="form-control" style={{ minHeight: "38px", backgroundColor: "LightGrey" }}> 
                                {clienteSelecionado?.dtNascimento! ? format(new Date(clienteSelecionado.dtNascimento!), 'dd/MM/yyyy') : 'N/A'}
                              </div>
                            </div>
                            <div className="col-md-4">
                              <label>Data Inclusão</label>
                              <div className="form-control" style={{ minHeight: "38px", backgroundColor: "LightGrey" }}>
                                {historicoSelecionado.dtInclusao ? historicoSelecionado.dtInclusao : 'N/A'}
                              </div>
                            </div>
                            <div className="col-md-4">
                              <label>Data Alteração</label>
                              <div className="form-control" style={{ minHeight: "38px", backgroundColor: "LightGrey" }}>
                                {historicoSelecionado.dtAprovacao ? historicoSelecionado.dtAprovacao : 'N/A'}
                              </div>
                            </div>
                          </div>
                          <div className="row mt-3">
                            <div className="col-md-6">
                              <label>Usuário Inclusão</label>
                              <div className="form-control" style={{ minHeight: "38px", backgroundColor: "LightGrey" }}>
                                {historicoSelecionado.usuarioInclusao || 'N/A'}
                              </div>
                            </div>
                            <div className="col-md-6">
                              <label>Usuário Alteração</label>
                              <div className="form-control" style={{ minHeight: "38px", backgroundColor: "LightGrey" }}>
                                {historicoSelecionado.usuarioAprovacao || 'N/A'}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="modal-footer">
                      {/* Botões de Aprovar/Reprovar - só aparecem se o status for PEN */}
                      {isStatusPendente(historicoSelecionado) && (
                        <>
                          <button 
                            type="button" 
                            className="btn btn-success"
                            onClick={() => aprovarReprovarAtualizacao(true)}
                            style={{ marginRight: '10px' }}
                          >
                            <FontAwesomeIcon icon={faCheck} style={{ marginRight: '5px' }} />
                            Aprovar
                          </button>
                          <button 
                            type="button" 
                            className="btn btn-danger"
                            onClick={() => aprovarReprovarAtualizacao(false)}
                            style={{ marginRight: '10px' }}
                          >
                            <FontAwesomeIcon icon={faTimes} style={{ marginRight: '5px' }} />
                            Reprovar
                          </button>
                        </>
                      )}
                      <button type="button" className="btn btn-secondary" onClick={fecharModal}>
                        Fechar
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </>
        )}
        <ScrollToTopButton />
      </div>
    </>
  );
}

export default ClienteConsultaHistoricoComponent;